/*eslint-disable*/
import React, { useState } from "react";
import { Container } from "reactstrap";

// Copy drawn from forge/1-focus.md … forge/5-execute.md (disclosure: public)
const STAGES = [
  {
    letter: "F",
    name: "Focus",
    decides: "What the business is actually trying to achieve",
    start:
      "An executive who can move budget is in the room. Not a delegate — a session only produces priorities if the person setting them can fund what follows.",
    done:
      "Every outcome has a metric, a named owner, and either a current value or an explicit admission that nobody measures it.",
    fails:
      "Aspirations instead of outcomes. “Become an AI-driven company” cannot be measured, owned, or finished.",
  },
  {
    letter: "O",
    name: "Observe",
    decides: "What is actually true",
    start:
      "Focus is done, and we have access to at least two people who do the work daily. Without that, we are interviewing management about a process they don't run.",
    done:
      "Each outcome traces to at least one constraint supported by evidence. Every constraint names its source.",
    fails:
      "Only talking to leadership. The described process and the real process differ, and the gap between them is usually where the money is.",
  },
  {
    letter: "R",
    name: "Rank",
    decides: "What is worth pursuing, in what order",
    start:
      "The constraint map exists and every constraint carries evidence. An unsupported constraint can't be scored honestly.",
    done:
      "At least one candidate sits on a non-AI path, or we can explain why none does. The sponsor has picked a shortlist and can say why.",
    fails:
      "The scorer has a stake in the outcome. Someone who wants a project funded will not call their own idea a two.",
  },
  {
    letter: "G",
    name: "Ground",
    decides: "What earns investment",
    start:
      "A ranked portfolio exists, with the top three carrying written rationale. We can't underwrite what we can't argue for.",
    done:
      "Every funded opportunity has a baseline, a target, a measurement method the metric owner agreed to, and a written decision rule.",
    fails:
      "The baseline is asserted, not measured. You can't demonstrate improvement against a number nobody agreed to beforehand.",
  },
  {
    letter: "E",
    name: "Execute",
    decides: "Whether it works, and whether to keep it",
    start:
      "A decision rule is already on paper. Writing one now would mean writing it in sight of the answer.",
    done:
      "The result is reported against the original baseline and the original rule — honestly, including when the honest answer is stop.",
    fails:
      "The decision rule gets renegotiated because the result disappointed. That is how a Proof of Value quietly becomes a permanent pilot.",
  },
];

function ForgeMethod() {
  const [active, setActive] = useState(0);
  const stage = STAGES[active];

  return (
    <section className="edge-forge-section" id="method">
      <Container>
        <span className="edge-section-eyebrow">{"// THE METHOD"}</span>
        <h2 className="edge-section-heading">
          Five stages.<br />
          <span className="muted">One decision each.</span>
        </h2>
        <p className="edge-section-sub">
          FORGE runs on every engagement. What changes between a two-week assessment and a
          six-month build is depth — never which stages happen.
        </p>

        <div className="edge-forge-rail" role="tablist" aria-label="The FORGE method">
          {STAGES.map((s, i) => (
            <button
              key={s.letter}
              type="button"
              role="tab"
              id={`forge-tab-${i}`}
              aria-selected={i === active}
              aria-controls="forge-detail"
              className={`edge-forge-stage${i === active ? " active" : ""}`}
              onClick={() => setActive(i)}
            >
              <span className="edge-forge-letter">{s.letter}</span>
              <span className="edge-forge-name">{s.name}</span>
              <span className="edge-forge-decides">{s.decides}</span>
            </button>
          ))}
        </div>

        <dl
          className="edge-forge-detail"
          id="forge-detail"
          role="tabpanel"
          aria-labelledby={`forge-tab-${active}`}
        >
          <div>
            <dt>Start when</dt>
            <dd>{stage.start}</dd>
          </div>
          <div>
            <dt>Done when</dt>
            <dd>{stage.done}</dd>
          </div>
          <div>
            <dt className="fail">How it fails</dt>
            <dd>{stage.fails}</dd>
          </div>
        </dl>

        <p className="edge-forge-foot">SCALE the relationship · FORGE the solution</p>
      </Container>
    </section>
  );
}

export default ForgeMethod;
